// @flow
import React, { type Node as ReactNode } from 'react'
import { CheckedBar } from '../../../Bars/'
import { TableHeader } from '../TableHeader'
import styles from '../../Main.css'

type MainRowProps = {
  data: Array<Object>,
  textMaxLength: number,
  highestNumber: number,
  fields: Array<Object>,
  type: string,
  caption: string
}

export const MainRows = ({
  data,
  textMaxLength,
  highestNumber,
  fields,
  type,
  caption
}: MainRowProps): ReactNode => {
  if (!data && !data.length) return null
  const RowArray = data.map(dataValue => {
    return (
      <CheckedBar
        key={`${dataValue.id}-bar-main`}
        data={dataValue}
        textOffset={textMaxLength}
        highestNumber={highestNumber}
        fields={fields}
        type={type}
      />
    )
  })
  return (
    <table className={styles.main}>
      <caption className="nrk-sr">{caption}</caption>

      <TableHeader type={type} fields={fields} />
      <tbody>{RowArray}</tbody>
    </table>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/Main/Rows/MainRows/index.js